import { AnchorLink } from '../../AnchorLink';
import { RichTextComponent, isElement } from '../utils';

export const Anchor: RichTextComponent = (node, children) =>
  isElement(node) && node.name === 'a' ? (
    <AnchorLink {...node.attribs} path={node.attribs.href}>
      {children}
    </AnchorLink>
  ) : null;
